import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useState, useEffect } from 'react';
import { ITag } from 'services/api/entities';
import { resetTags, tagSelectionFromURL } from 'services/store/tags/actions';
import initialState from 'services/store/tags/initialState';
import type {
  SongsStore,
  StoreRootState,
  TagStore,
} from 'services/store/types';

type UseTagsStore = {
  tagsStore: TagStore;
  tagName?: ITag | string;
  areTagsOrFiltersApplied: boolean;
  selectTagsFromURL: (selectedTags: Record<string, Array<string>>) => void;
  resetTags: () => void;
  setTagName: (tagName: string) => void;
};

const useTagsStore = (tagId?: string | ITag): UseTagsStore => {
  const [tagName, setTagName] = useState<string>('');
  const dispatch = useDispatch();
  const tagsStore: TagStore = useSelector(
    (store: StoreRootState) => store.tags
  );
  const songsStore: SongsStore = useSelector(
    (store: StoreRootState) => store.songs
  );
  const checkIfTagsOrFiltersAreApplied = (): boolean => {
    if (tagsStore) {
      const { selectedTags, appliedFilters } = tagsStore;
      return (
        Object.keys(selectedTags).length !== 0 ||
        !_.isEqual(appliedFilters, initialState.appliedFilters)
      );
    }
    return false;
  };

  // Get the genre name from the genre id
  useEffect(() => {
    // @ts-ignore
    if (songsStore?.entities) {
      // @ts-ignore
      const { tags } = songsStore.entities;
      if (tagId) {
        setTagName(tags[tagId as string]?.name);
      } else {
        setTagName('No Genre');
      }
    }
    // @ts-ignore
  }, [songsStore?.entities, tagId]);

  return {
    setTagName,
    tagName,
    tagsStore,
    areTagsOrFiltersApplied: checkIfTagsOrFiltersAreApplied(),
    selectTagsFromURL: (selectedTags: Record<string, Array<string>>): void => {
      dispatch(tagSelectionFromURL({ selectedTags }));
    },
    resetTags: (): void => {
      dispatch(resetTags());
    },
  };
};

export default useTagsStore;
